type State = {
  notify: Maybe<(..._args: unknown[]) => void>;
};

const state: State = {
  notify: null,
};

export default state;
